import { Routes, Route, Navigate } from 'react-router-dom'

import ProfileAccountInfoView from 'Presentation/Views/Profile/AccountInfo/View'
import ProfileImagesView from 'Presentation/Views/Profile/Images/View'
import ProfileBusinessInfoView from 'Presentation/Views/Profile/BusinessInfo/View'
import ProfileBankInfoView from 'Presentation/Views/Profile/BankInfo/View'
import ProfileLogisticView from 'Presentation/Views/Profile/Logistic/View'
import ProfileUserMangementView from 'Presentation/Views/Profile/Users/View'
import ProfileUserProfileView from 'Presentation/Views/Profile/UserProfile/View'
import ProfilePlanView from 'Presentation/Views/Profile/Plan/View'
import ProfileNotificationView from 'Presentation/Views/Profile/Notifications/View'
import ProfileCertificatesView from 'Presentation/Views/Profile/Certificates/View'
import ProfileSupplierFeaturesView from 'Presentation/Views/Profile/SupplierFeatures/View'

import { BusinessLocationSelectionContextProvider } from 'Presentation/Views/Profile/BusinessLocationSelection/Context'
import ProfileLogisticContextProvider from 'Presentation/Views/Profile/Logistic/Provider'
import ProfileUserManagementContextProvider from 'Presentation/Views/Profile/Users/Provider'

const ProfileRoutes = () => (
	<Routes>
		{/* Route:: Account Info */}
		<Route
			path="account-info"
			element={
				<BusinessLocationSelectionContextProvider>
					<ProfileAccountInfoView />
				</BusinessLocationSelectionContextProvider>
			}
		/>
		{/* Route:: Account Info */}

		{/* Route:: Images */}
		<Route path="images" element={<ProfileImagesView />} />
		{/* Route:: Images */}

		{/* Route:: Business Info */}
		<Route path="business-info" element={<ProfileBusinessInfoView />} />
		{/* Route:: Business Info */}

		{/* Route:: Bank Info */}
		<Route path="bank-info" element={<ProfileBankInfoView />} />
		{/* Route:: Bank Info */}

		{/* Route:: User Profile */}
		<Route path="user-profile" element={<ProfileUserProfileView />} />
		{/* Route:: User Profile */}

		{/* Route:: Logistic */}
		<Route
			path="logistic"
			element={
				<ProfileLogisticContextProvider>
					<ProfileLogisticView />
				</ProfileLogisticContextProvider>
			}
		/>
		{/* Route:: Logistic */}

		{/* Route:: User Management */}
		<Route
			path="users"
			element={
				<ProfileUserManagementContextProvider>
					<ProfileUserMangementView />
				</ProfileUserManagementContextProvider>
			}
		/>
		{/* Route:: User Management */}

		{/* Route:: Plan */}
		<Route path="plan" element={<ProfilePlanView />} />
		{/* Route:: Plan */}

		{/* Route:: Notifications */}
		<Route path="notifications" element={<ProfileNotificationView />} />
		{/* Route:: Notifications */}

		{/* Route:: Certificates */}
		<Route path="certificates" element={<ProfileCertificatesView />} />
		{/* Route:: Certificates */}

		{/* Route:: Supplier Features */}
		<Route path="supplier-features" element={<ProfileSupplierFeaturesView />} />
		{/* Route:: Supplier Features */}

		{/* Route: Products Default */}
		<Route index element={<Navigate to="/profile/account-info" />} />
		<Route path="*" element={<Navigate to="/error/404" />} />
	</Routes>
)

export default ProfileRoutes
